import DataTable from 'react-data-table-component';
import Constant from '../../Constant/UserLayout';
import { Link } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import Url from '../../Elements/Api/Api';
import { useSelector } from 'react-redux';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';

import axios from 'axios';
import { ClipLoader } from 'react-spinners';
import { css } from '@emotion/react';
import Header from '../../Constant/Header';

const TeamLeads = (props) => {
  const [show, setShow] = useState(false);
  const [searchStaffByName, setSearhStaffByName] = useState('');
  const [searchClient, setSearchClient] = useState('');
  const [itemOffset, setItemOffset] = useState(1);
  const [leadData, setLeadData] = useState([]);
  const [searchClientByName, setSearchClientByName] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [deleteRow, setDeleteRow] = useState([]);
  const [response, setResponse] = useState([]);
  const [id, setId] = useState('');
  const [clientLists, setClientLists] = useState([]);
  const token = useSelector((state) => state.token);
  // function for date paicker

  const [selectedDate, setSelectedDate] = useState('');
  const [selectedDate2, setSelectedDate2] = useState('');
  const [loading, setLoading] = useState(false);
  const override = css`
    display: block;
    margin: 0 auto;
  `;
  //sorting of leadname
  const [isArrowObj, setIsArrowObj] = useState({
    column: 'lead_name',
    orderby: 'asc'
  });
  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
  };
  const formattedDate = selectedDate ? format(selectedDate, 'dd/MM/yyyy') : '';
  const formattedDate2 = selectedDate2
    ? format(selectedDate2, 'dd/MM/yyyy')
    : '';

  // using useeffect hook to render functionality with the api
  useEffect(() => {
    getBrandList();
  }, [
    searchClient,
    itemOffset,
    deleteRow,
    id,
    formattedDate,
    formattedDate2,
    isArrowObj,
    pageCount
  ]);
  const getBrandList = () => {
    setLoading(true);
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    axios
      .get(
        Url.BASEURL +
          'getleads?' +
          'search=' +
          searchClient +
          '&page=' +
          itemOffset +
          '&staffid=' +
          id +
          '&from=' +
          formattedDate +
          '&to=' +
          formattedDate2 +
          '&orderby=' +
          isArrowObj.column +
          '&sortby=' +
          isArrowObj.orderby,
        config
      )
      .then(
        (value) =>
          setLeadData(value.data.response.data) &
          setPageCount(value.data.response.last_page) &
          setLoading(false)
      )
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (leadData) {
      setResponse(leadData);
      console.log('clientdata', leadData);
    }
  }, [leadData, searchClient, deleteRow]);
  // function for pagination
  const handlePageClick = (event) => {
    const newOffset = event.selected + 1;

    setItemOffset(newOffset);
  };

  // function for search
  const handleKeyPress = () => {
    setItemOffset(0);
    setSearchClientByName(searchClientByName);
  };
  const StaffChangeHandler = (event) => {
    setId(event.target.value);
  };

  useEffect(() => {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
    axios
      .get(Url.BASEURL + 'staffnameunderteammanager', config)
      .then(
        (value) =>
          setClientLists(value.data.response) &
          setPageCount(value.data.response.last_page)
      )
      .catch((err) => console.log(err));
  }, []);
  // function for sort data
  const handleArrowClick = (param, orderby) => {
    if (isArrowObj && isArrowObj.column == param) {
      orderby = isArrowObj && isArrowObj.orderby == 'asc' ? 'desc' : 'asc';
    } else {
      orderby = orderby == 'asc' ? 'desc' : 'asc';
    }
    const isArrowobjData = {
      column: param,
      orderby: orderby
    };
    setIsArrowObj(isArrowobjData);
  };
  return (
    <div>
      <Constant>
        <Header
          onpage_link="Team's Leads"
          heading="Team's Leads"
          btn_path="addlead"
        />
        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
            <div className="searchbar_border" style={{ marginTop: '20px' }}>
              <div
                className="search-field d-none d-md-block"
                style={{ marginBottom: '13px' }}
              >
                <div
                  className="d-flex align-items-center h-100 searchbar_parent"
                  action="#"
                >
                  <div
                    className="input-group merchant_search_bar border_radius searchbar_size"
                    style={{
                      borderWidth: 1,
                      borderRadius: 5
                    }}
                  >
                    <div className="input-group-prepend bg-transparent"></div>
                    <input
                      style={{
                        height: 30
                      }}
                      onChange={(e) =>
                        setSearchClient(e.target.value) & handleKeyPress()
                      }
                      type="text"
                      className="form-control bg-transparent border-0"
                      placeholder="Search"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>From</label>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                dateFormat="dd-MM-yyyy"
                placeholderText="Select a date"
                // isClearable={true}
                yearDropdown
                scrollableYearDropdown
                showYearDropdown={true}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <label>To</label>
              <DatePicker
                selected={selectedDate2}
                onChange={handleDateChange2}
                dateFormat="dd-MM-yyyy"
                placeholderText="Select a date"
                // isClearable={true}
                yearDropdown
                scrollableYearDropdown
                showYearDropdown={true}
              />
            </div>
            <select
              onChange={StaffChangeHandler}
              id="select1"
              class="ct_listing border_radius ct_listing_float ct_listing_margin "
              style={{
                borderWidth: '1px',
                borderRadius: '8px',
                width: '190px',
                marginBottom: '13px',
                borderColor: '0.5px solid black',
                marginTop: '20px'
              }}
            >
              {clientLists.map((e) => {
                return <option value={e.id}>{e.name}</option>;
              })}
              <option value="">Select Client</option>
            </select>
          </div>
          <div
            id="kt_app_content_container"
            className="app-container container-fluid"
          >
            <div className="col-xxl-12 mb-5 mb-xl-10">
              <div className="card card-flush h-xl-100">
                {loading ? (
                  <div
                    className="spinner-container"
                    style={{ alignSelf: 'center' }}
                  >
                    <ClipLoader
                      color={'#50CD89'}
                      loading={loading}
                      css={override}
                      size={60}
                    />
                  </div>
                ) : (
                  <div className="">
                    {/*begin::Tab content*/}
                    <div className="tab-content">
                      <div className=" mb-5 mb-xl-8">
                        {/*begin::Body*/}
                        <div className="card-body py-3">
                          {/*begin::Table container*/}
                          <div className="table-responsive">
                            {/*begin::Table*/}
                            <table className="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3">
                              {/*begin::Table head*/}
                              <thead>
                                <tr className="fw-bold text-muted">
                                  <th className="min-w-150px">
                                    {' '}
                                    <span style={{ marginRight: '3px' }}>
                                      {/* <i
                                      onClick={() =>
                                        handleArrowClick('created_at', 'asc')
                                      }
                                      class={
                                        isArrowObj &&
                                        isArrowObj.column == 'created_at' &&
                                        isArrowObj.orderby == 'desc'
                                          ? 'fa-solid fa-arrow-down'
                                          : 'fa-solid fa-arrow-up'
                                      }
                                      style={{}}
                                    ></i> */}
                                    </span>
                                    Lead Created
                                  </th>
                                  <th className="min-w-150px">
                                    {' '}
                                    <span style={{ marginRight: '3px' }}>
                                      <i
                                        onClick={() =>
                                          handleArrowClick('name', 'asc')
                                        }
                                        class={
                                          isArrowObj &&
                                          isArrowObj.column == 'name' &&
                                          isArrowObj.orderby == 'desc'
                                            ? 'fa-solid fa-arrow-down'
                                            : 'fa-solid fa-arrow-up'
                                        }
                                        style={{}}
                                      ></i>
                                    </span>
                                    Organisation
                                  </th>
                                  <th className="min-w-150px">
                                    {' '}
                                    <span style={{ marginRight: '3px' }}>
                                      <i
                                        onClick={() =>
                                          handleArrowClick('name', 'asc')
                                        }
                                        class={
                                          isArrowObj &&
                                          isArrowObj.column == 'name' &&
                                          isArrowObj.orderby == 'desc'
                                            ? 'fa-solid fa-arrow-down'
                                            : 'fa-solid fa-arrow-up'
                                        }
                                        style={{}}
                                      ></i>
                                    </span>
                                    Staff member
                                  </th>
                                  <th className="min-w-140px">
                                    {' '}
                                    <span style={{ marginRight: '3px' }}>
                                      <i
                                        onClick={() =>
                                          handleArrowClick('lead_name', 'asc')
                                        }
                                        class={
                                          isArrowObj &&
                                          isArrowObj.column == 'lead_name' &&
                                          isArrowObj.orderby == 'desc'
                                            ? 'fa-solid fa-arrow-down'
                                            : 'fa-solid fa-arrow-up'
                                        }
                                        style={{}}
                                      ></i>
                                    </span>
                                    Client Name
                                  </th>
                                  <th className="min-w-120px">
                                    {' '}
                                    <span style={{ marginRight: '3px' }}>
                                      <i
                                        onClick={() =>
                                          handleArrowClick('stage', 'asc')
                                        }
                                        class={
                                          isArrowObj &&
                                          isArrowObj.column == 'stage' &&
                                          isArrowObj.orderby == 'desc'
                                            ? 'fa-solid fa-arrow-down'
                                            : 'fa-solid fa-arrow-up'
                                        }
                                        style={{}}
                                      ></i>
                                    </span>
                                    Status
                                  </th>

                                  {/* <th className="min-w-100px text-end">
                                    Actions
                                  </th> */}
                                </tr>
                              </thead>
                              {/*end::Table head*/}
                              {/*begin::Table body*/}
                              <tbody>
                                {leadData.length === 0 ? (
                                  <tr>
                                    <td colSpan="5" className="text-center">
                                      No Record found
                                    </td>
                                  </tr>
                                ) : (
                                  leadData.map((e, index) => (
                                    <tr key={index}>
                                      <td>{e.created_at}</td>
                                      <td>{e.lead_organisation}</td>

                                      <td>{e.staff.name}</td>
                                      <td>{e.client_data.clientInfo[0].contact_person_name_0}</td>
                                      <td>{e.leadstage.stage}</td>
                                      {/* <td className="text-end">
                                        <a
                                          href="#"
                                          className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                        >
                                          <i className="ki-duotone ki-pencil fs-2">
                                            <span className="path1" />
                                            <span className="path2" />
                                          </i>{' '}
                                        </a>
                                        <a
                                          href="#"
                                          className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                        >
                                          <i className="ki-duotone ki-trash fs-2">
                                            <span className="path1" />
                                            <span className="path2" />
                                            <span className="path3" />
                                            <span className="path4" />
                                            <span className="path5" />
                                          </i>{' '}
                                        </a>
                                      </td> */}
                                    </tr>
                                  ))
                                )}
                              </tbody>

                              {/*end::Table body*/}
                            </table>
                            {/*end::Table*/}
                          </div>
                          {/*end::Table container*/}
                        </div>
                        {/*begin::Body*/}
                      </div>

                      {/*begin::Tab pane*/}

                      {/*end::Tab pane*/}
                      {/*begin::Tab pane*/}

                      {/*end::Tab pane*/}
                    </div>
                    {/*end::Tab content*/}
                  </div>
                )}
                {/*end::Body*/}
              </div>
              {/*end::Chart widget 8*/}
            </div>
          </div>
        </div>
      </Constant>
    </div>
  );
};

export default TeamLeads;
